import React, { useEffect, useState, useContext } from "react";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import DateFnsUtils from '@date-io/date-fns'; // choose your lib
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import Validation from "./Validation";
import useFetch from './useFetch'
import { ThemeContext } from '../Helper/Context'


const Signup = ({ onSubmit }) => {
    const [{ response, setResponse }, dofetch] = useFetch();
    const [apiName, setApiName] = useState(null)
    const [geoStates, setGeoStates] = useState([])
    const [geoStatesSuggestion, setGeoStatesSuggestion] = useState([])
    const [geoCities, setGeoCities] = useState([])
    const [geoCitiesSuggestion, setGeoCitiesSuggestion] = useState([])
    const { mainState, setMainState } = useContext(ThemeContext);
    const { setShowLoader } = useContext(ThemeContext)
    const [errors, setErrors] = useState({ errors: true })
    const params = new URLSearchParams(window.location.search);
    const [values, setValues] = useState({
        firstName: {
            value: '',
            required: true,
            type: 'text'
        },
        lastName: {
            value: '',
            required: true,
            type: 'text'
        },
        birthDate: {
            value: null,
            required: true,
            type: 'date'
        },
        gender: {
            value: '',
            required: true,
            type: 'radio'
        },
        phoneNumber: {
            value: '',
            required: true,
            type: 'phone'
        },
        email: {
            value: params ? params.get("email") : '',
            required: true,
            type: 'email'
        },
        citizenship: {
            value: '',
            required: false,
            type: 'text'
        },
        street: {
            value: '',
            required: true,
            type: 'text'
        },
        suburb: {
            value: '',
            required: true,
            type: 'text'
        },
        postalCode: {
            value: '',
            required: true,
            type: 'text'
        },
        state: {
            value: '',
            required: false,
            type: 'text',
            id: 6
        },
        city: {
            value: '',
            required: true,
            type: 'text',
            id: null,
            cityName: ''
        },
        country: {
            value: 'AU',
            required: true,
            type: 'text'
        },
        emergencyContactName: {
            value: '',
            required: true,
            type: 'text'
        },
        emergencyContactRelation: {
            value: '',
            required: true,
            type: 'text'
        },
        emergencyContactNumber: {
            value: '',
            required: true,
            type: 'text'
        },

    })

    const handleDate = (date) => {
        setValues(prevState => ({
            ...prevState,
            birthDate: {
                ...prevState.birthDate, value: date
            }
        }))
    }
    const handleChange = (e) => {
        setValues(prevState => ({
            ...prevState,
            [e.target.name]: {
                ...prevState[e.target.name], value: e.target.value
            }
        }))
    }
    const handleAutoComplete = (e, geoType, geo) => {
        let field = e.target.value;
        setValues(prevState => ({
            ...prevState,
            [geo]: {
                ...prevState[geo], value: e.target.value
            }
        }))
        let matches = [];
        console.log(geoType)
        if (field.length > 0 && geoType.length > 0) {
            matches = geoType.filter(geo => {
                const regex = new RegExp(`${field}`, "gi");
                return geo.name.match(regex);
            })
        }
        if (geo == 'state') {
            setGeoStatesSuggestion(matches);
        } else {
            setGeoCitiesSuggestion(matches);
        }

        console.log('matches', matches);
    }
    const handleCityAutoComplete = e => {
        let field = e.target.value;
        setValues(prevState => ({
            ...prevState,
            suburb: {
                ...prevState.suburb, value: e.target.value
            }
        }))

        if (field.length > 2) {
            console.log(field)
            setApiName('cities');
            let urlParams = "?$filter=countryId eq 14 and contains(name, '" + field + "')";
            dofetch(mainState.fetchURL, 'cities', 'cities.get.odata', urlParams, '', true, true)
        }
    }
    const handleSetGeo = (e, geo) => {
        let selectedOption = e.target.firstChild.nodeValue;
        let selectedOptionID = e.target.getAttribute("data-geoid");
        console.log(selectedOptionID)
        console.log(selectedOptionID.length)
        setValues(prevState => ({
            ...prevState,
            [geo]: {
                ...prevState[geo],
                value: selectedOption,
                id: selectedOptionID,
                cityName: selectedOption
            },
            suburb:{
                ...prevState.suburb,
                value:selectedOption
            }
        }))
        if (geo == 'state') {
            setGeoStatesSuggestion([]);
        } else {
            setGeoCitiesSuggestion([]);
        }
    }

    const handleFormSubmit = (e) => {
        e.preventDefault();
        console.log(errors)
        setErrors(Validation(values));
    }
    console.log(values);

    const submitData = (e) => {
        setShowLoader(true)
        setErrors(true);

        console.log(values);
        let date = new Date(values.birthDate.value);
        let formatedDate = date.getFullYear() + '-' + ("0" + (date.getMonth() + 1)).slice(-2) + '-' + ("0" + date.getDate()).slice(-2);
        let userData = {
            homeClubId: 1,
            personalData: {
                firstName: values.firstName.value,
                lastName: values.lastName.value,
                birthDate: formatedDate,
                sex: values.gender.value,
                phoneNumber: values.phoneNumber.value,
                email: values.email.value,
                citizenshipCountrySymbol: "AU",
                personalId: values.firstName.value.substring(0, 2) + "." + formatedDate.substring(0, 4)+ "." + values.lastName.value.substring(0, 2) + ".gu",
                // Citizenship: values.citizenship.value,
                Citizenship: 'Australia',
            },
            addressData: {
                street: values.street.value + ", " + values.suburb.value,
                postalCode: values.postalCode.value,
                stateId: values.state.id,
                cityId: values.city.id,
                countrySymbol: "AU"
            },
            customAttributes: [
                {
                    customAttributeTypeId: 9,
                    value: values.emergencyContactName.value
                },
                {
                    customAttributeTypeId: 10,
                    value: values.emergencyContactNumber.value
                },
                {
                    customAttributeTypeId: 11,
                    value: values.emergencyContactRelation.value
                },
            ]
        }

        console.log(userData);
        let fetchURL = mainState.fetchURL;
        let myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Cookie", "CMSPreferredCulture=en-AU");

        let raw = JSON.stringify({
            "integrationcode": "PERFECTGYMAPI",
            "endpointname": "AddGuestMember",
            "internalcall": "AddGuestMember.post.odata",
            "useheadervariables": true,
            "body": JSON.stringify(userData)
        });

        console.log(raw);
        let requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(fetchURL, requestOptions)
            .then(response => response.json())
            .then(res => {
                setShowLoader(false)
                if (res.errors) {
                    if('Value already exist in system' === res.errors[0].message){
                        setErrors({emailExist: true})
                    }
                } else {

                    setMainState(prevState => ({
                        ...prevState,
                        section: 'dashboard',
                        isLoggedIn: true,
                        user: {
                            ...prevState.user,
                            userId: res.memberId,
                            newUser: true,
                            firstName: userData.personalData.firstName,
                            lastName: userData.personalData.lastName,
                            email: userData.personalData.email,
                            sex: userData.personalData.sex,
                            phoneNumber: userData.personalData.phoneNumber,
                            birthdate: userData.personalData.birthDate,
                            address: userData.addressData,
                            paymentSources: []
                        }

                    }))
                }

            })
            .catch(error => alert('error', error));
    }
    const clickOutSide = e => {
        if (e.target.className !== "geo-option") {
            setGeoStatesSuggestion([]);
            setGeoCitiesSuggestion([]);
        }
    }

    // console.log(geoStates);;
    useEffect(() => {
        if (!errors) {
            submitData();
        }
    }, [errors]);

    // useEffect(()=>{
    //     if(response){
    //         setShowLoader(false);
    //         if(apiName == "cities"){
    //             console.log(response.value);
    //             setGeoCities(response.value);

    //         }else{
    //             setGeoStates(response.value);
    //             setApiName('cities');
    //             let urlParams = "?$filter=countryId eq 14";
    //             dofetch(mainState.fetchURL, 'cities', 'cities.get.odata', urlParams, '');
    //         }
    //     }else{
    //         let urlParams = "?$filter=countryId eq 14";
    //         dofetch(mainState.fetchURL, 'states', 'states.get.odata', urlParams, '');
    //     }
    // },[response, apiName])
    useEffect(() => {
        console.log('call');
        setShowLoader(false);
        if (response) {
            if (apiName == "cities") {
                // setGeoCities(response.value);
                let JSONbig = require('json-bigint');
                let bigres = JSONbig.parse(response);
                console.log(bigres.value);
                setGeoCitiesSuggestion(bigres.value);
            }
        }
    }, [response, apiName])

    return (
        <div className="signup" onClick={(e) => clickOutSide(e)}>
            <p>Please review the current details we have for you, make any changes and confirm. We’ll get to your child next.</p>

            <h2>Your details (Parent/Guardian):</h2>
            {/* <h2>Your personal details</h2> */}
            <div className="form">
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="firstname">First name</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="firstname" name="firstName" placeholder="Type your first name"
                                value={values.firstName.value}
                                onChange={e => handleChange(e)} />
                        </div>
                        {errors.firstName &&
                            <span className="EditingFormErrorLabel">Please enter first name</span>
                        }
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="lastname">Last name</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="lastname" name="lastName" placeholder="Type your last name"
                                value={values.lastName.value}
                                onChange={e => handleChange(e)} />
                        </div>
                        {errors.lastName &&
                            <span className="EditingFormErrorLabel">Please enter last name</span>
                        }
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="dateOfBirth">Birth date</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control datepickercontrol">
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    letiant="inline"
                                    format="dd/MM/yyyy"
                                    value={values.birthDate.value}
                                    onChange={date => handleDate(date)}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                        {errors.birthDate &&
                            <span className="EditingFormErrorLabel">Please enter valid birth date</span>
                        }
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-element">
                        <span className="label">Gender</span>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <span className="radio radio-list-horizontal">
                                <input id="Male" type="radio" name="gender" defaultValue="Male" onChange={e => handleChange(e)} />
                                <label htmlFor="Male">Male</label>
                                <input id="Female" type="radio" name="gender" defaultValue="Female" onChange={e => handleChange(e)} />
                                <label htmlFor="Female">Female</label>
                                <input id="prefernottosay" type="radio" name="gender" defaultValue="Prefer not to say" onChange={e => handleChange(e)} />
                                <label htmlFor="prefernottosay">Prefer not to say</label>
                            </span>
                        </div>
                        {errors.gender &&
                            <span className="EditingFormErrorLabel">Please select gender</span>
                        }
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="phoneNumber">Phone number</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="phoneNumber" name="phoneNumber" placeholder="0400 000 000"
                                value={values.phoneNumber.value}
                                onChange={e => handleChange(e)} />
                        </div>
                        {errors.phoneNumber &&
                            <span className="EditingFormErrorLabel">Please enter valid phone number</span>
                        }
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="email">Email</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="email" name="email" placeholder="Type your email address"
                                value={values.email.value}
                                onChange={e => handleChange(e)} />
                        </div>
                        {errors.email &&
                            <span className="EditingFormErrorLabel">Please enter valid email address</span>
                        }
                    </div>
                </div>
                {/* <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="citizenship">Citizenship</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="citizenship" name="citizenship" placeholder="Type your citizenship"
                                value={values.citizenship.value}
                                onChange={e => handleChange(e)} />
                        </div>
                        {errors.citizenship &&
                            <span className="EditingFormErrorLabel">Please enter citizenship</span>
                        }
                    </div>
                </div> */}
                <h3>Address details:</h3>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="street">Street</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="street" name="street" placeholder="Type your street name and number"
                                value={values.street.value}
                                onChange={e => handleChange(e)} />
                        </div>
                        {errors.street &&
                            <span className="EditingFormErrorLabel">Please enter street</span>
                        }
                    </div>
                </div>
                {/* <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="suburb">Suburb</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="suburb" name="suburb" placeholder="Type your suburb"
                                value={values.suburb.value}
                                onChange={e => handleChange(e)} />
                        </div>
                        {errors.suburb &&
                            <span className="EditingFormErrorLabel">Please enter suburb</span>
                        }
                    </div>
                </div> */}
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="suburb">Suburb</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="suburb" name="suburb" placeholder="Type your suburb" autoComplete="aa"
                                value={values.suburb.value}
                                onChange={e => handleCityAutoComplete(e)} />
                            {geoCitiesSuggestion.length > 0 &&
                                <div className="geoSuggestion">
                                    <ul>
                                        {geoCitiesSuggestion.map((city, index) => {
                                            return <li className="geo-option" key={index} data-geoid={city.id.toString()} onClick={(e) => handleSetGeo(e, 'city')}>{city.name}</li>
                                        })}
                                    </ul>
                                </div>
                            }
                        </div>

                        {errors.suburb &&
                            <span className="EditingFormErrorLabel">Please enter suburb</span>
                        }
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="postalCode">Postal code</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="postalCode" name="postalCode" placeholder="0000"
                                value={values.postalCode.value}
                                onChange={e => handleChange(e)} />
                        </div>
                        {errors.postalCode &&
                            <span className="EditingFormErrorLabel">Please enter postal code</span>
                        }
                    </div>
                </div>
                {/* <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="state">State</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="state" name="state" placeholder="Type your state" autoComplete="aa"
                            value={values.state.value}
                            onChange={e => handleAutoComplete(e, geoStates, 'state')}/>
                            {geoStatesSuggestion.length > 0 &&
                                <div className="geoSuggestion">
                                    <ul>
                                        {geoStatesSuggestion.map((state, index)=>{
                                            return <li className="geo-option" key={index} data-geoid={state.id} onClick={(e) => handleSetGeo(e,'state')}>{state.name}</li>
                                        })}
                                    </ul>
                                </div>
                            }
                        </div>
                        
                        {errors.state &&
                        <span className="EditingFormErrorLabel">Please enter state</span>
                        }
                    </div>
                </div> */}

                {/* <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="city">City</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="city" name="city" placeholder="Type your city" autoComplete="aa"
                                value={values.city.value}
                                onChange={e => handleCityAutoComplete(e)} />
                            {geoCitiesSuggestion.length > 0 &&
                                <div className="geoSuggestion">
                                    <ul>
                                        {geoCitiesSuggestion.map((city, index) => {
                                            return <li className="geo-option" key={index} data-geoid={city.id.toString()} onClick={(e) => handleSetGeo(e, 'city')}>{city.name}</li>
                                        })}
                                    </ul>
                                </div>
                            }
                        </div>

                        {errors.city &&
                            <span className="EditingFormErrorLabel">Please enter city</span>
                        }
                    </div>
                </div> */}
                <h3>Emergency contact details:</h3>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="emergencyContactName">Emergency contact name</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="emergencyContactName" name="emergencyContactName" placeholder="Type emergency contact name"
                                value={values.emergencyContactName.value}
                                onChange={e => handleChange(e)} />
                        </div>
                        {errors.emergencyContactName &&
                            <span className="EditingFormErrorLabel">Please enter emergency contact name</span>
                        }
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="emergencyContactRelation">Emergency contact relation</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="emergencyContactRelation" name="emergencyContactRelation" placeholder="Type your emergency contact relation"
                                value={values.emergencyContactRelation.value}
                                onChange={e => handleChange(e)} />
                        </div>
                        {errors.emergencyContactRelation &&
                            <span className="EditingFormErrorLabel">Please enter emergency contact relation</span>
                        }
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-element">
                        <label className="EditingFormLabel" htmlFor="emergencyContactNumber">Emergency contact number</label>
                        <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input type="text" className="form-control" id="emergencyContactNumber" name="emergencyContactNumber" placeholder="0400 000 000"
                                value={values.emergencyContactNumber.value}
                                onChange={e => handleChange(e)} />
                        </div>
                        {errors.emergencyContactNumber &&
                            <span className="EditingFormErrorLabel">Please enter emergency contact number</span>
                        }
                    </div>
                </div>
                {errors.emailExist && 
                    <span className="EditingFormErrorLabel">Email has already been registered</span>
                }
                <div className="form-row form-row-submit">
                    
                    <div className="form-element">
                        <input type="submit" className="FormButton btn" value="Register Parent/Guardian" onClick={(e) => handleFormSubmit(e)} />
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Signup